import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from './PageContext';
import PageDropdown from './PageDropdownCopy.jsx';
import OrderedDataTable from './OrderedDataTableCopy.jsx';
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import AdhocDataRow from './AdhocDataRow';
import CCOffcanvas from './CCOffcanvas.tsx';


const EditAdhocPaymentModal = ({ refreshFunction }) => {
    // initialize PageContext
    const {
        showMarkPaymentFailedModal, 
        setShowMarkPaymentFailedModal, 
        markPaymentFailedRow, 
        adhocTableHeader,
        masterCompanyId,
        showSpinner, 
        snackbarAlert,
    } = useContext(PageContext);
    // initialize HttpContext
    const {
        PUT,
    } = useContext(HttpContext);
    // initialize state
    const [optionList, setOptionList] = useState(['Successful', 'Failed']); 
    const [status, setStatus] = useState('Successful'); 
    const [markPaymentFailedData, setMarkPaymentFailedData] = useState([]); 
    const [markPaymentFailedTableHeader, setMarkPaymentFailedTableHeader] = useState([]); 
    // initialize ref to determine initialRender
    const initialRender = useRef(true);

    // function wrapper to pass row component to datatable
    const RowComponent = (row, count, tableHeader,stickyEnabled) =>{
        return( 
            <>
                <AdhocDataRow row={row} count={count} tableHeader={tableHeader} editBool={false} stickyEnabled={stickyEnabled}/>
            </>
        );
    } 

    // event handler for submit click 
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            // get boolean from dropdown string 
            let failed = false 
            if (status == 'Failed') {
                failed = true; 
            }
            // use function to make request
            let response; 
            PUT('/data/markPaymentFailed', {
                mastercompanyid: masterCompanyId,
                paymentid: markPaymentFailedRow['paymentid'],
                failed: failed, 
            }).then(res => {
                console.log(res);
                response = res;
                // hide modal 
                setShowMarkPaymentFailedModal(showMarkPaymentFailedModal => showMarkPaymentFailedModal = false);
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh data on page
                return refreshFunction();
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            });
        }); 
    }

    // useEffect to set state on row change 
    useEffect(() => {
        if (initialRender.current == false) {
            // set failed status option
            if (markPaymentFailedRow['failed'] == true) {
                setStatus(status => status = 'Failed'); 
            }
            else {
                setStatus(status => status = 'Successful'); 
            }
            // set data for data table 
            setMarkPaymentFailedData(markPaymentFailedData => markPaymentFailedData = [markPaymentFailedRow]); 
            // set table header 
            setMarkPaymentFailedTableHeader(markPaymentFailedTableHeader => markPaymentFailedTableHeader = adhocTableHeader); 
        }
        else {
            initialRender.current = false;
        }
    }, [markPaymentFailedRow]);

    return (
        <>
            <CCOffcanvas
                title='Mark Payment Failed'
                onCanvasClose={() => setShowMarkPaymentFailedModal(showMarkPaymentFailedModal => showMarkPaymentFailedModal = false)}
                show={showMarkPaymentFailedModal}
                bodyCssClassName="offcanvas-body"
                offCanvasClassName="offcanvas-parent-card"
            >   
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column flex-grow-1 overflow-scroll">
                        <div className="p-3 trail-section">
                            <div className="bg-white trail-card">
                                <OrderedDataTable disableMaxTableHeight={true} RowComponent={RowComponent} dataList={markPaymentFailedData} tableHeader={markPaymentFailedTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true} sortingEnabled={true}/>
                            </div>
                        </div>
                        <div className="p-3 trail-section">
                            <div className="bg-white trail-card d-flex align-items-center justify-content-start p-2">
                                <PageDropdown tag='Status' value={status} setValue={setStatus} list={optionList} />
                            </div>
                        </div>
                    </div>
                    <div    
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default EditAdhocPaymentModal;